import styled from '@emotion/styled/macro';
import { rem } from '@feast-it/pesto';

export const Container = styled.div`
  background: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.shadows[1]};
  border-radius: ${({ theme }) => theme.radii[2]};
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: ${({ theme }) => `${theme.space[4]} ${theme.space[2]}`};
  max-width: ${rem(328)};
  width: 100%;
`;

export const Arrow = styled.div`
  background: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.shadows[1]};
  height: ${rem(16)};
  width: ${rem(16)};
  position: absolute;
  transform: translateY(${rem(24)}) rotate(45deg);
`;
